









import { Component, Vue } from 'vue-property-decorator';

import PortalIcon from '@/components/icons/PortalIcon.vue';

@Component({
  components: {
    PortalIcon,
  },
})
export default class XsollaCopy extends Vue {}
